import { useCallback } from 'react';
import FileSaver from 'file-saver';
import template from '../../../../public/resources/Bulk Import Streams Template.xlsm';

export const useDownloadTemplate = () => {
  const downloadTemplate = useCallback(
    /**
     * Downloads a bulk stream import template file.
     * 
     * @param {string} [filename='createStreamsTemplate.xlsm'] The name of the download file
     * @param {*} file The template file contents to be downloaded
     */
    (filename = 'Bulk-streams-template.xlsm', file = template) => {
      FileSaver.saveAs(file, filename);
    },
    []
  );
  return downloadTemplate;
};